import CustomFab from './FAB';

export default CustomFab;